// extracted by mini-css-extract-plugin
module.exports = {"pdf_container":"_1NGGKRk","pdf_container_no_wrapper":"_1U_quRu","wrapper":"_4blj_jQ"};